module.exports = __webpack_public_path__ + "static/media/Trapinch_gaussian2.ded257e8.png";